import React from 'react';
import { Card, Typography } from '@mui/material';
import { Science as ExperimentIcon } from '@mui/icons-material';

const EmptyState = () => {
  return (
    <Card sx={{ p: 4, textAlign: 'center' }}>
      <ExperimentIcon sx={{ fontSize: 64, color: 'text.secondary', mb: 2 }} />
      <Typography variant="h6" color="text.secondary" gutterBottom>
        No Experiments Found
      </Typography>
      <Typography variant="body2" color="text.secondary">
        This template doesn't have any A/B test experiments yet.
      </Typography>
    </Card>
  );
};

export default EmptyState;
